import React from 'react';

function TimeDistribution({ summary, t }) {
  if (!summary) return null;

  const { corte_pct = 0, restante_pct = 0, entre_cortes_pct = 0 } = summary;

  const bars = [
    { label: "Corte Efetivo", value: corte_pct, color: "bg-emerald-500" },
    { label: "Máquina Parada", value: restante_pct, color: "bg-amber-500" },
    { label: "Entre Marcadas", value: entre_cortes_pct, color: "bg-red-500" },
  ];

  return (
    <div className={`${t.card} rounded-lg p-6`}>
      <h3 className={`text-sm font-semibold ${t.text} mb-4`} style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
        Distribuição do Tempo
      </h3>
      <div className="space-y-4">
        {bars.map((bar, i) => (
          <div key={i}>
            <div className="flex justify-between text-xs mb-1">
              <span className={t.textBody}>{bar.label}</span>
              <span className={`font-medium ${t.text}`}>{bar.value.toFixed(1)}%</span>
            </div>
            <div className={`h-3 ${t.barTrack} rounded-full overflow-hidden`}>
              <div 
                className={`h-full ${bar.color} transition-all duration-500 rounded-full`}
                style={{ width: `${bar.value}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TimeDistribution;
